import './feed.css';
import { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { axiosInstance } from '../../config.util';

export default function Feed(){
    const [query, setQuery] = useState("");
    const [searchedData, setSearchedData] = useState([]);
    useEffect(()=>{
        const fetchUsers = async()=>{
            const res = await axiosInstance.get('/users/allusers')
            setSearchedData(res.data);
        }
        fetchUsers();
    },[])
    console.log(searchedData);
    return(
        <div className="feed__container">
            <div className="search__feed">
                <input type="text"  placeholder='Search' onChange={e=>setQuery(e.target.value)}/>
            </div>
            <div className="main__feed-container">
                <div className="main__feed-container-wrap">
                    {searchedData
                    .filter((user)=>user.username.toLowerCase().includes(query))
                    .map((user)=>(
                        <div className="usersearch-wrap__block">
                            <Link to={`/profile/${user.username}`} state={{searchUsrId: user.id}}>
                                <div className="usersearch__block-container">
                                    <div className="usersearch-wrap__block-img">
                                        <img src={user?.avatar} alt="" />
                                    </div>
                                    <div className="feed-wrap__container-desc">
                                        <div className="usersearch_liketo">
                                            <h2 key={user.id}>{user.username}</h2>
                                        </div>
                                        <p>{user?.desc}</p>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}